// TROIA-V3-FRONTEND/src/modules/crm/seller-dashboard/components/MyLevelCard.tsx
import React from 'react';
import type { GamificationLevel } from '@troia-v3/types';

import { DashCard } from '@/shared/components/ui';

import { formatPts, levelProgress } from '../lib/sellerFormat';

import '../seller-dashboard.css';

interface MyLevelCardProps { totalPoints: number; level: GamificationLevel; nextLevel?: GamificationLevel; }

/** "Meu nível" — mockup 07 (.lvl + .lvl-bar). Reusado no mobile sem o cabeçalho. */
export const LevelProgress: React.FC<MyLevelCardProps> = ({ totalPoints, level, nextLevel }) => {
  const { pct, missing } = levelProgress(totalPoints, level, nextLevel);
  return (
    <div className="flex items-center gap-3.5" data-testid="seller-level-progress">
      <div className="seller-lvl-badge">{level.name.toUpperCase()}</div>
      <div className="flex-1 min-w-0">
        <div className="flex justify-between text-[13px]">
          <b style={{ color: 'var(--theme-card-text)' }}>{formatPts(totalPoints)} pts</b>
          <span style={{ color: 'var(--theme-muted-text)' }}>{nextLevel ? `${nextLevel.name} em ${formatPts(nextLevel.minPoints)}` : 'Nível máximo'}</span>
        </div>
        <div className="seller-lvl-bar mt-2" role="progressbar" aria-valuenow={pct} aria-valuemin={0} aria-valuemax={100}><i style={{ width: `${pct}%` }} /></div>
        {nextLevel && <div className="text-xs mt-1.5" style={{ color: 'var(--theme-muted-text)' }}>Faltam {formatPts(missing)} pontos para o próximo nível.</div>}
      </div>
    </div>
  );
};

export const MyLevelCard: React.FC<MyLevelCardProps> = (props) => (
  <DashCard icon="zap" title="Meu nível" subtitle="Pontos acumulados — nunca zera" testId="seller-level">
    <LevelProgress {...props} />
  </DashCard>
);
MyLevelCard.displayName = 'MyLevelCard';
